module.exports = __webpack_public_path__ + "img/jietu.f494ab09.png";